import React from "react";

const AchievementRing = ({ percentage = 0, size = 160, lineCount = 60 }) => {
  const center = size / 2;
  const radius = center - 15;
  const anglePerLine = 360 / lineCount;
  const activeLines = Math.round((percentage / 100) * lineCount);

  const getLineColor = (index) => {
    const progress = (index / lineCount) * 100;
    if (progress < 30) return "#e74c3c";
    if (progress < 70) return "#f39c12";
    return "#2ecc71";
  };

  const lines = Array.from({ length: lineCount }, (_, i) => {
    const angle = -90 + i * anglePerLine;
    const rad = (angle * Math.PI) / 180;
    const x1 = center + radius * Math.cos(rad);
    const y1 = center + radius * Math.sin(rad);
    const x2 = center + (radius - 10) * Math.cos(rad);
    const y2 = center + (radius - 10) * Math.sin(rad);
    return (
      <line
        key={i}
        x1={x1}
        y1={y1}
        x2={x2}
        y2={y2}
        stroke={i < activeLines ? getLineColor(i) : "#ddd"}
        strokeWidth={2}
      />
    );
  });

  return (
    <div className="d-flex flex-column align-items-center">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        {lines}
        <text
          x="50%"
          y="55%"
          textAnchor="middle"
          fontSize="22"
          fontWeight="bold"
          fill="#34495e"
          style={{ fontFamily: "Cairo" }}
        >
          {percentage.toFixed(1)}%
        </text>
      </svg>
      <p style={{ fontFamily: "Cairo", fontWeight: "500", marginTop: "10px" }}>
        نسبة الإنجاز
      </p>
    </div>
  );
};

export default AchievementRing;
